import { APP_ROLE } from '@/config/env'
import { i18n } from '@/plugins/i18n'

export function getBrandTitle() {
  const key = `app.titleByRole.${APP_ROLE}`
  return i18n.global.te(key) ? i18n.global.t(key) : i18n.global.t('app.title')
}

export function setPageTitle(parts = []) {
  const list = (Array.isArray(parts) ? parts : [parts])
    .map((part) => String(part ?? '').trim())
    .filter(Boolean)
  const brand = getBrandTitle()
  document.title = list.length ? `${list.join(' — ')} | ${brand}` : brand
}

export function setMetaDescription(description = '') {
  if (typeof document === 'undefined') {
    return
  }

  const content = String(description ?? '').trim()
  let meta = document.querySelector('meta[name="description"]')
  if (!meta) {
    meta = document.createElement('meta')
    meta.setAttribute('name', 'description')
    document.head.appendChild(meta)
  }
  meta.setAttribute('content', content)
}

export function applyRouteTitle(route) {
  const matched = [...(route?.matched ?? [])].reverse()
  const withKey = matched.find((record) => record.meta?.titleKey)
  if (!withKey) {
    setPageTitle()
    return
  }

  const titleKey = withKey.meta.titleKey
  if (i18n.global.te(titleKey)) {
    setPageTitle(i18n.global.t(titleKey))
    return
  }

  setPageTitle()
}
